
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/events/details",
      function () {
        return require("private-next-pages/events/details.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/events/details"])
      });
    }
  